import { createContext } from 'react';
import type { Job } from './types';

interface ContextValue {
  job: Job | null;
}

const Context = createContext<ContextValue>({
  job: null,
});

export default Context;
